import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { getSysFieldid } from '@platform/api';
import { Tooltip } from '@platform/base';
import ColGroup from './ColGroup';

export default forwardRef(function TableFooter(props, ref) {
    /**
     * —————————————————————————————————————— render —————————————————————————————————————— 
     */
    let { 
        rows, 
        rowHeight, 
        columnInfo, 
        totalConfig = {}, 
        isFixLeft, 
        isFixRight, 
        footer, 
        locale, 
        hasVerticalScrollBar,
        hasHorizontalScrollBar,
        scrollBarSize,
        fixedBottom,
        bodyWidth,
    } = props;
    
    let { 
        left: { leafColumns: leftColumns },
        middle: { leafColumns: middleColumns },
        right: { leafColumns: rightColumns },
        leaf: { columns: leafColumns },
        useTotal,
    } = columnInfo;
    let { enable, render, text = locale['table002'] /*'合计'*/ } = totalConfig;

    let horizontalScrollBarSize = hasHorizontalScrollBar ? scrollBarSize : 0;
    !hasVerticalScrollBar && (scrollBarSize = 0);

    return <>
        <div 
            ref={ref}
            className={classnames(
                "table-wrapper", 
                "table-next-footer-wrapper", 
                { 'fix-bottom': fixedBottom },
            )}
            style={{ 
                bottom: fixedBottom ? horizontalScrollBarSize : 'auto',
                width: fixedBottom ? bodyWidth : 'auto',
            }}
            fieldid={getSysFieldid('total-row')}
        >
            {typeof footer === 'function' && footer()}
            {(enable || useTotal) && <table className="table-next-footer">
                <ColGroup {...props}></ColGroup>
                <tfoot>
                    {typeof render === 'function'
                        ? 
                        <tr style={{ height: rowHeight }}>
                            <td colSpan={leafColumns.length}>
                                {render()}
                            </td>
                        </tr>
                        : 
                        <tr style={{ height: rowHeight }}>
                            {leftColumns.length > 0 && <td 
                                className={classnames(
                                    'table-next-body-cell', 
                                    'fixed-left', 
                                    { 
                                        'is-fixing': isFixLeft,
                                        'last-left-column': true,
                                    },
                                    'sticky',
                                )}
                                style={{ left: 0 }}
                                colSpan={leftColumns.length}
                            >
                                <Tooltip
                                    className="tooltip-word-color table-pagination-tip"
                                    placement="top"
                                    delay={1}
                                    overlay={text}
                                >
                                    {text}
                                </Tooltip>
                            </td>}
                            {middleColumns.map((column, index) => {
                                let { key, total, itemtype } = column,
                                    display = total?.(rows);

                                return <td 
                                    key={key} 
                                    className={`footer-type-${itemtype}`}
                                    fieldid={getSysFieldid(key)}
                                >
                                    {leftColumns.length === 0 && index === 0 && text}
                                    <Tooltip
                                        className="tooltip-word-color table-pagination-tip"
                                        placement="top"
                                        delay={1}
                                        overlay={display}
                                    >
                                        {display}
                                    </Tooltip>
                                </td>;
                            })}
                            {rightColumns.length > 0 && <td 
                                className={classnames(
                                    'table-next-body-cell', 
                                    'fixed-right', 
                                    { 
                                        'is-fixing': isFixRight,
                                        'first-right-column': true,
                                    },
                                    'sticky',
                                )}
                                style={{ right: scrollBarSize }}
                                colSpan={rightColumns.length}
                            ></td>}
                        </tr>
                    }
                </tfoot>
            </table>}
            {renderScrollBarBlank()}
        </div>
        {fixedBottom && <div style={{ 
            height: ref.current.offsetHeight,
            width: bodyWidth,
            flex: 'none',
        }}></div>}
    </>;

    function renderScrollBarBlank() {
        return hasVerticalScrollBar && <div className="scroll-bar-blank" style={{ width: scrollBarSize }}></div>;
    }
});